var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconarrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4821 11C17.7048 11 17.8164 10.7307 17.6589 10.5732L13.3231 6.23751C13.0303 5.94462 13.0303 5.46975 13.3231 5.17685L13.6767 4.8233C13.9696 4.53041 14.4445 4.53041 14.7374 4.8233L20.9874 11.0733C21.128 11.214 21.207 11.4047 21.207 11.6036V12.3965C21.207 12.5954 21.128 12.7862 20.9874 12.9269L14.7374 19.1769C14.4445 19.4697 13.9696 19.4697 13.6767 19.1769L13.3231 18.8233C13.0303 18.5304 13.0303 18.0555 13.3231 17.7626L17.659 13.4268C17.8165 13.2693 17.705 13 17.4822 13H4.25C3.83579 13 3.5 12.6642 3.5 12.25V11.75C3.5 11.3358 3.83579 11 4.25 11H17.4821Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconarrowright);
export default __webpack_public_path__ + "static/media/icon.arrow.right.f750338dc67af741fface38690decf1f.svg";
export { ForwardRef as ReactComponent };